/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { createUnits } from "../../requesters/Backend/UnitRequester"
import { emailRegex } from "../../util/regex"

function UpdateOrgPage({
  baseUrl, currentUser, fetchOrganisationDetail, onChangeEditable, organisationDetail
}) {
  const [form, setForm] = useState({
    organisation_id: organisationDetail?.id
  })
  const [showErrors, setShowErrors] = useState(false)
  const [isValidEmail, setIsValidEmail] = useState(true)
  const requiredValues = [
    "organisation_id",
    "name",
    "contact_name",
    "contact_email",
    "contact_number"
  ]

  const onSubmit = () => {
    setShowErrors(true)
    if (requiredValues.every(k => k in form) && isValidEmail) {
      createUnits(baseUrl, form, currentUser).then(() => {
        fetchOrganisationDetail()
        onChangeEditable()
      })
    }
  }

  const onChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  useEffect(() => {
    // Keep email validity in sync with contact_email changes.
    setIsValidEmail(emailRegex.test(form.contact_email))
  }, [form.contact_email])

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="form-container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/backend">Organisation</Link>
              </li>
              <li className="breadcrumb-item">
                <Link className="breadcrumb-item" onClick={onChangeEditable} to={`/backend/organisations/${organisationDetail.id}`}>{organisationDetail.name}</Link>
              </li>
              <li aria-current="page" className="breadcrumb-item active">Add New</li>
            </ol>
          </nav>
          <h1>Add New</h1>
          <div className="card-section">
            <div className="card">
              <div className="card-header"><h5>Organisation &amp; Unit</h5></div>
              <div className="card-body">
                <div className="form-group">
                  <label>Organisation name</label>
                  <input className="form-control" type="search" name="organisation_name" value={organisationDetail.name} />
                </div>
                <div className="form-group">
                  <label>Unit</label>
                  <input className="form-control" type="text" name="name" onChange={onChange} />
                  {showErrors && !form.name
                    && <div className="err-msg text-danger">Unit Name is required</div>}
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header"><h5>Contact</h5></div>
              <div className="card-body">
                <div className="form-group">
                  <label>Contact name</label>
                  <input className="form-control" type="text" name="contact_name" onChange={onChange} />
                  {showErrors && !form.contact_name
                    && <div className="err-msg text-danger">Contact Name is required</div>}
                </div>
                <div className="form-group">
                  <label>Contact email</label>
                  <input className="form-control" type="email" name="contact_email" onChange={onChange} />
                  {showErrors && !form.contact_email
                    && <div className="err-msg text-danger">Contact email is required</div>}
                  {showErrors && !isValidEmail
                    && <div className="err-msg text-danger">Contact email is invalid</div>}
                </div>
                <div className="form-group">
                  <label>Contact number</label>
                  <input className="form-control" type="text" name="contact_number" onChange={onChange} maxLength="10" pattern="[0-9]{10}" />
                  {showErrors && !form.contact_number
                    && <div className="err-msg text-danger">Contact number is required</div>}
                </div>
              </div>
            </div>
          </div>
          <div className="form-container-cta fixed-bottom">
            <div className="btn btn-outline-main" onClick={onChangeEditable}>Cancel</div>
            <button type="button" className="btn btn-main" onClick={onSubmit}>Create</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdateOrgPage
